// extracted by mini-css-extract-plugin
export default {"error":"styles_error__7TGO+","wrapper":"styles_wrapper__tQPAj"};